module.exports = __webpack_public_path__ + "static/media/margarita-at-the-bar-cabreras.5bdd925a.jpg";